import { render, staticRenderFns } from "./FoodOrder.vue?vue&type=template&id=d45cf6aa"
import script from "./FoodOrder.vue?vue&type=script&lang=js"
export * from "./FoodOrder.vue?vue&type=script&lang=js"
import style0 from "./FoodOrder.vue?vue&type=style&index=0&id=d45cf6aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports